import { isEmpty } from "lodash";
import DetectRTC from "detectrtc";
import { toast } from "react-toastify";
import reduxStore from "../../../configureEnvStore";
import { CALL_DATA, GLOBAL_MEETING_DATA, PublicVariables } from "../../../constants/PublicVariables";
import {
    resetCommonReducer,
    setActiveuserlist,
    setCallParticipants,
    setIsCallDisconnected,
    setIsRemoteParticipantJoined,
    setIsVideoButtonClickDisable,
    setNewActiveUserlist,
    setPartiCountForDisplay,
    setParticipantCount,
    setRemoteParticipantesDeviceInfo,
    setRequestMicCameraModalsData,
    setShowCallDisconnectedPopup,
} from "../../../reducers/common-reducer";
import {
    resetTwilioEventsReducer,
    setNotAllowedCamera,
    setAudioError,
    setAudioErrorModal,
    setIsAnyVideoAvailableInTheRoom,
    setParticipantIdentities,
    setStartLocalVideo,
    setStreamingDetails,
    setStreamingPartiIdentity,
    setVideoError,
    addDisconnectedUser,
    setDataTrack,
    setAllAudioTrackIdentity,
    setAllUserAudioStatus,
} from "../../../reducers/twilioEvents-reducer";
import { dualStreamEnabled, isAgentIdentity, isSilentObserver, singleUserEnabled, totalTimeInSeconds } from "../../../shared/utility";

import newUserJoinSound from "../../../assets/audio/user_join.mp3";
import userDisconnectSound from "../../../assets/audio/User_Leave.mp3";
import {
    handleSendVideoScreenShareDataTrack,
    micCameraPermissionDatatrackSend,
    sendDataTrack,
    sendMsgForPointer,
    toggleActionButtons,
} from "../../../shared/dataTrackFunction";
import { setAudioPermission, setCameraPermission } from "../../../reducers/call-setting-reducer";
import { CAMERA_FACING_MODE, ERROR_TYPE, MEDIA_PERMISSIONS, QUALITY_TYPE_MAP } from "../../../constants/CallSettingConstants";
import chatService from "../../../services/chatService";
import { handleEndCallAPI } from "../../../actions/endCallAction";
import { AR_MARKUP_VIEW, DEVICE_TYPES, ENABLED, EXTRACT_TEXT_VIEW, MARKUP_VIEW } from "../../../constants/Constants";
import uploadMapService from "../../../services/WatermarkImage/uploadMapService";
import { resetBatteryAndNetworkInfoReducer } from "../../../reducers/battery-network-info-reducer";
import { isScreenshareTrack, stopScreenShare } from "../ScreenShare/ScreenShareUtils";
import waitingScreenService from "../../../services/waitingScreenService";
import { NOTIFICATION_TYPES } from "../../../constants/DataTrackNotificationConstants";
import { resetImageConatiner } from "../../../reducers/imageContainer-reducer";
import { resetJoinCallReducer } from "../../../actions/joinMeetingAction";
import { resetRecordingReducer } from "../../../reducers/recording-reducer";
import { checkIsRecoridngIsStarted, hideRecordingErrorView } from "../../Recording/RecordingUtils";
import { isLiveStreamFeatureSupported } from "../../Markup/MarkupFunction";
import extractTextService from "../../../services/extractTextService";
import livePointerService from "../../LivePointer/livePointerService";
import { showLatLongForStreaming } from "../../LiveLocation/LocationUtils";
import { resetLiveLocationReducer } from "../../../reducers/live-location-reducer";
import { addVideoPausedCheck, performStartStopVideo, playIfVideoIsPaused, unpublishVideo } from "../VideoCall/VideoUtils";
import { resetExtractTextReducer, setExtractTextInprogress } from "../../../reducers/extractText-reducer";
import { setMediate, setSurveyForObserver } from "../../../reducers/silentObserver-reducer";
import navigatorService from "../../../services/navigatorService";
import { LogFirebase } from "../../../services/firestore";
import zoomService from "../../../services/zoomService";
import googleEvent from "../../../services/googleEvent";
import { EVENT_NAME } from "../../../constants/GTagConstants";
import { STATUS } from "../../../constants/LivePointerConstants";
import { handleAllEnabledAudioTrackIdenity, handleRemoveEnabledAudioTrackIdenity, remoteParticipantAudioChecker } from "../AudioCall/AudioCallUtils";
import markupService from "../../../services/MarkupService/markupService";
import { resetMarkupReducer, setARMarkupStatusPopup, setARMarkupToastMsgStatus, setCallannview } from "../../../reducers/markup-reducer";
import { END_CALL_EVENTS } from "../../../reducers/endCall-reducer";
import { BOOKMARK_EVENTS } from "../../../reducers/bookmark-reducer";
import { NOTES_EVENTS } from "../../../reducers/notes-reducer";
import { resetlivePointerReducer } from "../../../reducers/livePointer-reducer";
import { resetGalleryViewReducer } from "../../../reducers/gallery-view-reducer";
import { manageScreenShareinMultiStream, showGridView } from "../../GalleryView/GalleryViewUtils";
import { resetChatReducer } from "../../../reducers/chat-reducer";
import uploadFilesService from "../../../services/uploadFilesService";
import { getRoom } from "./roomService";
import { updateOrAddParticipant, updateStreamingStatusOnEvent } from "../videoScreenShareOverrideFunction";
import {
    attachTracks,
    detachParticipantTracks,
    discontinueRoom,
    getPublishVideoContainer,
    getVideoContainer,
    getTracksByType,
    removeLocalAudioElement,
    removeVideoElement,
    getActiveRoom,
} from "../twilioCallUtility";
import { resetTrackFailedReducer } from "../../../reducers/track-failed-reducer";
import { checkLivePointerOn } from "../../LivePointer/LivePointerUtils";
import { resetMeasurementReducer } from "../../../reducers/measurement-reducer";
import measurementService from "../../../services/measurementService";
import { AR_MEASUREMENT_ACTION } from "../../../constants/MeasurementConstants";
import callStatsService from "../../../services/callStatsService";
import { setRemoteDataForCallStats } from "../../../reducers/callstats-reducer";
// import { VideoRoomMonitor } from "@twilio/video-room-monitor";
import arMarkupService from "../../../services/MarkupService/arMarkupService";
import { addRemoveAutoWidthClass, changeSelectedCamera } from "../../CallScreens/CallTopbar/CallSettings/CallSettingUtils";
import Localize from "../../../locale/Localize";
import mediaDeviceService from "../../../services/mediaDeviceService";
import takePhotoService from "../../../services/takePhotoService";
import videoON from "../../../assets/audio/cam_on_click.wav";
import videoOff from "../../../assets/audio/cam_off_click.wav";
import micON from "../../../assets/audio/mic_on_click.wav";
import micOff from "../../../assets/audio/mic_off_click.wav";
import liveCaptionService from "../../../services/liveCaptionService";
import { resetLiveCaptionReducer } from "../../../reducers/liveCaption-reducer";
import audioTranslationService from "../../../services/audioTranslationService";
import { resetAudioTranslationReducer } from "../../../reducers/audioTranslation-reducer";

const isParticipantScreenSharing = (identity) => {
    const screenSharingIdentity = identity;
    return reduxStore.getState().twilioEvents.screenSharingUsers.includes(screenSharingIdentity);
};

const handleVideoStatusForScreenShare = (track, participantId) => {
    const str = track.name;
    const fristLtr = str.charAt(0);
    if (GLOBAL_MEETING_DATA.ucid) {
        if (fristLtr != "s") {
            if (participantId != CALL_DATA.localIdentity) {
                const oppScreenshare = reduxStore.getState().commonReducer.oppScreenshare;
                if (!oppScreenshare) {
                    setRemoteParticipanteAudioVideoStatus("video", participantId, track.isEnabled);
                }
            }
        } else {
            // Check if the participant is not the local user
            if (participantId != CALL_DATA.localIdentity) {
                const oppScreenshare = reduxStore.getState().commonReducer.oppScreenshare;
                // Only proceed if screen sharing is not active
                if (!oppScreenshare) {
                    setRemoteParticipanteAudioVideoStatus("video", participantId, false);
                }
            }
        }
    }
};

export const attachTracksToVideoElement = (participant, type, identity, retries) => {
    setTimeout(() => {
        const container = getVideoContainer(identity);

        removeVideoElement(container);
        const trackArray = getTracksByType(participant, type);

        if (container) {
            attachTracks(trackArray, container);
        } else if (retries > 0) {
            console.warn("Container not found. Retrying...");
            attachTracksToVideoElement(participant, type, retries - 1); // Retry
        } else {
            LogFirebase("Video", "track_subscribe_attachTracks", "Container not found after multiple attempts.");
            console.error("Container not found after multiple attempts.");
        }
    }, 200);
};

export const handleVideoSubscribedForSingleStream = (track, remoteTrackPrublication, participant) => {
    const { startLocalVideo, isLocalUserScreenSharing } = reduxStore.getState().twilioEvents;
    const { measurementInProgress, measurementStarted } = reduxStore.getState().measurement;
    if (isLocalUserScreenSharing) {
        stopScreenShare(false);
    }

    if (startLocalVideo === true && !dualStreamEnabled()) {
        // handle stop video on other participant video start if local video is ON
        unpublishVideo();
        reduxStore.dispatch(setStartLocalVideo(false)); // for local video button start/stop variable
    }

    if (isScreenshareTrack(track)) {
        const params = {
            isVideo: false,
            identity: participant.identity,
            isScreenShare: true,
            isLocalUser: true,
        };
        updateStreamingStatusOnEvent(params.isVideo, params.identity, params.isScreenShare, params.isLocalUser);
    } else {
        updateStreamingStatusOnEvent(true, participant.identity);
    }
    attachTracksToVideoElement(participant, "video", CALL_DATA.localIdentity, 10);

    if (!dualStreamEnabled()) {
        reduxStore.dispatch(setStreamingPartiIdentity(participant.identity)); // set streaming user identity
        setStreamingPartiDetails(participant.identity); // set streaming user object from callParticipant Array
    }
    reduxStore.dispatch(setIsAnyVideoAvailableInTheRoom(true)); // for UI viewing purpose variable

    setTimeout(() => {
        showLatLongForStreaming(); // show streaming user's location info below video
    }, 500);
    handleVideoStatusForScreenShare(track, participant.identity);
    if (measurementInProgress && !measurementStarted && !dualStreamEnabled()) {
        waitForVideoElement()
            .then((videoElement) => {
                LogFirebase("Measurement", "in_video_subscribe", "Video element found");
                setupVideoMeasurement(videoElement);
            })
            .catch((error) => {
                LogFirebase("Measurement", "in_video_subscribe", error.message);
            });
    }

    if (reduxStore.getState().markup.arMarkupLiveStream === AR_MARKUP_VIEW.PREPARE_VIEW && !arMarkupService.ARMarkupStarted && !dualStreamEnabled()) {
        waitForVideoElement()
            .then((videoElement) => {
                LogFirebase("ARMakup", "in_video_subscribe", "going_to_create_canvas");
                setupVideoARMarkup(videoElement);
            })
            .catch((error) => {
                LogFirebase("ARMakup", "in_video_subscribe", error.message);
            });
    }
    setTimeout(() => {
        if (PublicVariables.isIOSDevice) {
            playIfVideoIsPaused(null, participant.identity);
            addVideoPausedCheck.start(participant.identity); //add interval to check video pause
        }
    }, 1000);

    // Auto-start live pointer when remote video/screenshare is received - pass track for proper Twilio event handling
    const trackType = isScreenshareTrack(track) ? "remote_screenshare" : "remote_video";
    livePointerService.autoStartLivePointer(trackType, track);
};

export function waitForVideoElement(timeout = 5000) {
    return new Promise((resolve, reject) => {
        const interval = 100; // Check every 100ms
        let elapsedTime = 0;
        const checkVideoElement = () => {
            const videoElement = document.getElementById("expandedVideo")?.querySelector("video");
            if (videoElement) {
                resolve(videoElement);
            } else {
                elapsedTime += interval;
                if (elapsedTime >= timeout) {
                    reject(new Error("Video element not found within timeout"));
                } else {
                    setTimeout(checkVideoElement, interval);
                }
            }
        };
        checkVideoElement();
    });
}

function setupVideoMeasurement(videoElement) {
    let callMeasurement = true;
    videoElement.addEventListener("loadeddata", () => {
        if (videoElement.readyState >= 3) {
            setTimeout(() => {
                const { measurementInProgress } = reduxStore.getState().measurement;
                if (callMeasurement && measurementInProgress) {
                    callMeasurement = false; // Prevent duplicate handling
                    LogFirebase("Measurement", "in_video_subscribe", "Going to create canvas");
                    measurementService.manageMeasurementStatus(AR_MEASUREMENT_ACTION.SUPPORTED_READY_TO_START);
                }
            }, 1500);
        }
    });
}

function setupVideoARMarkup(videoElement) {
    let callMeasurement = true;
    videoElement.addEventListener("loadeddata", () => {
        if (videoElement.readyState >= 3) {
            setTimeout(() => {
                const { arMarkupLiveStream } = reduxStore.getState().markup;
                if (callMeasurement && arMarkupLiveStream === AR_MARKUP_VIEW.PREPARE_VIEW) {
                    callMeasurement = false; // Prevent duplicate handling
                    arMarkupService.ARMarkupShowPopupFunction(arMarkupService.popupStatus.supportedReadyToStart);
                }
            }, 50);
        }
    });
}

export const handleVideoSubscribedForMultiStream = (track, remoteTrackPrublication, participant) => {
    if (dualStreamEnabled()) {
        const participantDetails = {
            identity: participant.identity,
            isVideoStreaming: true, // or false
            isScreenShareStreaming: false,
            device_type: getUserDetailsById(participant.identity)?.device_type || null,
        };
        console.log("setGalleryViewConnectedUser_handleVideoSubscribedForMultiStream", participantDetails);

        // Call the function to update or add the participant
        updateOrAddParticipant(participantDetails);

        if (isScreenshareTrack(track)) {
            const params = {
                isVideo: false,
                identity: participant.identity,
                isScreenShare: true,
                isLocalUser: true,
            };
            updateStreamingStatusOnEvent(params.isVideo, params.identity, params.isScreenShare, params.isLocalUser);
        } else {
            updateStreamingStatusOnEvent(true, participant.identity);
        }
        attachTracksToVideoElement(participant, "video", participant.identity, 10);
        handleVideoStatusForScreenShare(track, participant.identity);
        if (isScreenshareTrack(track)) {
            checkLivePointerOn();
            manageScreenShareinMultiStream(participant.identity);
        }
        setTimeout(() => {
            if (PublicVariables.isIOSDevice) {
                playIfVideoIsPaused(null, participant.identity);
                addVideoPausedCheck.start(participant.identity); //add interval to check video pause
            }
        }, 1000);
    }
};

export const handleVideoTrackUnsubscribedForSingleStream = (track, remoteTrackPrublication, participant) => {
    const { streamingPartiIdentity } = reduxStore.getState().twilioEvents;
    addRemoveAutoWidthClass(false);
    if (streamingPartiIdentity === participant.identity || streamingPartiIdentity === null) {
        reduxStore.dispatch(setIsAnyVideoAvailableInTheRoom(false)); // for UI viewing purpose variable
    }

    if (participant.identity != CALL_DATA.localIdentity) {
        if (streamingPartiIdentity == participant.identity || streamingPartiIdentity == undefined) {
            checkLivePointerOn();
            const previewContainer = getPublishVideoContainer();
            removeVideoElement(previewContainer);
        }
    }
    if (isScreenshareTrack(track)) {
        const params = {
            isVideo: false,
            identity: participant.identity,
            isScreenShare: false,
            isLocalUser: false,
        };
        updateStreamingStatusOnEvent(params.isVideo, params.identity, params.isScreenShare, params.isLocalUser);
    } else {
        updateStreamingStatusOnEvent(false, participant.identity);
    }
    if (isvideoenabled()) {
        // do not remove video element
        console.log("do not remove video element");
    } else {
        //remove video element when video track unsubscribes
        const previewContainer = getPublishVideoContainer();
        removeVideoElement(previewContainer);
    }
};

export const handleVideoTrackUnsubscribedForMultiStream = (track, remoteTrackPrublication, participant) => {
    const { expandView } = reduxStore.getState().commonReducer;
    if (!expandView) {
        const previewContainer = getVideoContainer(participant.identity);
        removeVideoElement(previewContainer);
        updateStreamingStatusOnEvent(false, participant.identity);
    }

    const participantDetails = {
        identity: participant.identity,
        isVideoStreaming: false, // or false
        isScreenShareStreaming: false,
        device_type: getUserDetailsById(participant.identity)?.device_type || null,
    };
    console.log("setGalleryViewConnectedUser_handleVideoTrackUnsubscribedForMultiStream", participantDetails);

    // Call the function to update or add the participant
    updateOrAddParticipant(participantDetails);
};

export const handleStartLocalVideoTrackForSingleStream = () => {
    // old function publishVideo, performOnPublishVideo
    handleSendVideoScreenShareDataTrack("1", "1", "1"); // send data track for video stop
    const { expandView } = reduxStore.getState().commonReducer;
    if (!dualStreamEnabled() && expandView) {
        reduxStore.dispatch(setStreamingPartiIdentity(CALL_DATA.localIdentity)); // set streaming user identity
        setStreamingPartiDetails(CALL_DATA.localIdentity); // streaming user set
    }

    const participantArray = reduxStore.getState().commonReducer.callParticipants;
    const streamingIdentity = reduxStore.getState().twilioEvents.streamingPartiIdentity;
    const { pointerOn } = reduxStore.getState().livePointer;

    console.log("participantArray", participantArray);
    const updatedParticipants = participantArray.map((user) => {
        if (user.identity === streamingIdentity) {
            return { ...user, device_type: GLOBAL_MEETING_DATA.device_type };
        }
        return user;
    });
    console.log("updatedParticipants - ", updatedParticipants);
    // Dispatch an action to update the Redux store with the new participant array
    reduxStore.dispatch(setCallParticipants(updatedParticipants));
    reduxStore.dispatch(setIsAnyVideoAvailableInTheRoom(true)); // for UI viewing purpose variable
    reduxStore.dispatch(setCameraPermission(MEDIA_PERMISSIONS.GRANTED)); // set cameraPermission variable

    if (!dualStreamEnabled()) {
        //enable all features in single stream only
        if (pointerOn) {
            livePointerService.turnOffLivePointer();
            sendMsgForPointer(STATUS.OFF); // If Android APP SS ON and Web Override with the video if pointer is ON
        }
        sendMsgForPointer(STATUS.ENABLED);
        // Auto-start live pointer after local video override
        livePointerService.autoStartLivePointer("local_video_override");

        const info = {
            notification_type: NOTIFICATION_TYPES.VIDEO_SCREENSHARE_STATUS,
            identity: CALL_DATA.localIdentity,
            status: "1",
            device_type: GLOBAL_MEETING_DATA.device_type,
            is_videostream: "1",
            show_toast: "1",
        };
        //set feature action buttons
        toggleActionButtons(info);
    } else {
        //do nothing
    }
    //set selected camera for call settings
    const { workingCam, isFrontCameraSelected } = reduxStore.getState().callSetting;
    if (!workingCam && (DetectRTC.isMobileDevice || navigatorService.isIpadOS())) {
        const isCallSettingDrawerOpen = reduxStore.getState().commonReducer.isCallSettingDrawerOpen;
        if (!isCallSettingDrawerOpen) {
            const facingMode = isFrontCameraSelected ? CAMERA_FACING_MODE.FRONT : CAMERA_FACING_MODE.BACK;
            changeSelectedCamera(facingMode);
        }
    }

    micCameraPermissionDatatrackSend("cam"); // send data track for video permission status send to agent

    setTimeout(() => {
        showLatLongForStreaming(); // show streaming user's location info below video
    }, 500);
};

export const handleStopLocalVideoTrackForSingleStream = (identity) => {
    if (isLocalUserStreaming()) {
        handleSendVideoScreenShareDataTrack("0", "1", "1"); // send data track for video stop
        if (!isParticipantScreenSharing(identity)) {
            reduxStore.dispatch(setStreamingPartiIdentity(null)); // set streaming user identity
            reduxStore.dispatch(setStreamingDetails({})); // set streaming user object
        }
        reduxStore.dispatch(setIsAnyVideoAvailableInTheRoom(false)); // for UI viewing purpose variable
        if (PublicVariables.featureFlag.SHOWMEZOOM === ENABLED) {
            zoomService.callResetZoom();
        }
    }
};

export const checkIfVideoQualityIsHD = (device_type) => {
    const { currentSelectedVideoQuality } = reduxStore.getState().callSetting;
    return (
        currentSelectedVideoQuality?.value == QUALITY_TYPE_MAP.HD &&
        (device_type == DEVICE_TYPES.IOS_BROWSER ||
            device_type == DEVICE_TYPES.ANDROID_BROWSER ||
            device_type == DEVICE_TYPES.IOS_APP ||
            device_type == DEVICE_TYPES.ANDROID_APP)
    );
};

/* - use when we need to set streaming participant user object */
export const setStreamingPartiDetails = (participantId) => {
    const participantArray = reduxStore.getState().commonReducer.callParticipants;

    // Find the participant with the specified identity and dispatch streaming details
    const participant = participantArray.find((user) => user.identity === participantId);
    console.log("StreamingPartiDetails_____", participant);
    if (participant) {
        // for HD quality in iOS apply class
        if (checkIfVideoQualityIsHD(participant.device_type)) {
            if (participant.device_type == DEVICE_TYPES.IOS_APP || participant.device_type == DEVICE_TYPES.ANDROID_APP) {
                setTimeout(() => {
                    addRemoveAutoWidthClass(true);
                }, 2000);
            } else {
                addRemoveAutoWidthClass(true);
            }
        } else {
            addRemoveAutoWidthClass(false);
        }
        reduxStore.dispatch(setStreamingDetails(participant)); // set streaming user object
    }
};

/* - user when check currently local user is streaming user or not */
export const isLocalUserStreaming = () => {
    const streamingIdentity = reduxStore.getState().twilioEvents.streamingPartiIdentity;
    return streamingIdentity === CALL_DATA.localIdentity;
};

/* - use when reqest parameter identity is streaming identity */
export const isParticipantStreaming = (identity) => {
    const streamingIdentity = reduxStore.getState().twilioEvents.streamingPartiIdentity;
    return streamingIdentity == identity;
};

export const handleEndCallFunc = (fromMediate) => {
    if (!PublicVariables.isOnlyUploadImageMeet && !CALL_DATA.roomDisconnect) {
        CALL_DATA.roomDisconnect = true;
        const { startLocalVideo, isLocalUserScreenSharing, streamingPartiIdentity } = reduxStore.getState().twilioEvents;
        const { callDuration } = reduxStore.getState().commonReducer;
        const { pointerOn } = reduxStore.getState().livePointer;
        const isExtractTextInprogress = reduxStore.getState().extractText.extractTextInprogress;

        checkIsRecoridngIsStarted(); // this functiom call, if recording is ON and Agent disconnect the call then other user also stop the recoridng
        uploadFilesService.resetFlags();
        removeLocalAudioElement("endCall"); // remove audio track from the room

        //send message to other parti - for pointer enable/disable status for mobile apps.
        if (streamingPartiIdentity == CALL_DATA.localIdentity) {
            //for opponent participants
            if (pointerOn) {
                sendMsgForPointer(STATUS.OFF);
                sendMsgForPointer(STATUS.DISABLED);
            } else {
                sendMsgForPointer(STATUS.DISABLED);
            }
        }
        if (fromMediate) {
            reduxStore.dispatch(setMediate(true));
            reduxStore.dispatch(setSurveyForObserver(true));
        }
        LogFirebase("End_Call", "_endcall_fun_called", { identity: CALL_DATA.localIdentity });
        LogFirebase("End_Call", "_total_images_uploaded_in_call", {
            totalPhotosInCall: reduxStore.getState().imageContainerReducer.containerImagesArray.length,
        });

        //live pointer related
        if (pointerOn) {
            livePointerService.turnOffLivePointer();
        }
        if (startLocalVideo) {
            // if local video is ON, on end call then first stop the video
            if (dualStreamEnabled()) {
                if (expandViewEnabled() && isLocalUserStreaming()) {
                    showGridView(CALL_DATA.localIdentity, true); //safari bg/fg case
                }
            }
            performStartStopVideo();
        }
        if (isLocalUserScreenSharing) {
            // if local screen share is ON, on end call then first stop the screen share
            if (dualStreamEnabled()) {
                if (expandViewEnabled() && isLocalUserStreaming()) {
                    showGridView(CALL_DATA.localIdentity, true); //safari bg/fg case
                }
            }
            stopScreenShare();
        }

        if (isExtractTextInprogress === EXTRACT_TEXT_VIEW.OCR_VIEW || isExtractTextInprogress === EXTRACT_TEXT_VIEW.PREPARE_VIEW) {
            extractTextService.exitocrcanvas(false, false, false);
        } else {
            reduxStore.dispatch(setExtractTextInprogress(EXTRACT_TEXT_VIEW.OFF_VIEW));
        }

        if (navigatorService.isMobileDevice()) {
            zoomService.disablePinchZoom();
            setTimeout(function () {
                zoomService.resetPinchZoom(); // reset pinch zoom browser for local user
            }, 1000);
        }

        ////$scope.updateCookiTime(); // update cookie time

        //for guest user clearinterval of check location update
        if (GLOBAL_MEETING_DATA.isGuest && PublicVariables.locationIntervalId) {
            clearInterval(PublicVariables.locationIntervalId);
        }

        //for both agent and guest user clear navigator watch position
        if (PublicVariables.objWatchPositionId) {
            navigator.geolocation.clearWatch(PublicVariables.objWatchPositionId);
        }

        // for markup and check all scenario
        if (reduxStore.getState().markup.callannview || reduxStore.getState().markup.arMarkupLiveStream === AR_MARKUP_VIEW.START_MARKUP_VIEW) {
            markupService.fromEndCall = true;
            if (GLOBAL_MEETING_DATA.isAgent) {
                markupService.toggleannotationdiv(false, false, true);
            } else {
                markupService.toggleannotationdiv(true, false, true);
            }
            reduxStore.dispatch(setCallannview(false));
        }

        CALL_DATA.callDuration = totalTimeInSeconds(callDuration);
        if (GLOBAL_MEETING_DATA.isAgent) {
            // if agent
            chatService.handleAutoDownloadChat(); // handling auto download chat & reseting chatReducer
            extractTextService.sendOCRDataInEndCall(); // handling Auto-Save Extracted Text
            liveCaptionService.checkTranscriptForSummary(true); // handling AI transcription summary call data
        }
        googleEvent.logEvent(EVENT_NAME.CALL_DISCONNECTED);
        const payload = {
            callDuration: CALL_DATA.callDuration, //set callDuration here after implement it
            recordingRoom: CALL_DATA.recordingRoomKey,
        };
        reduxStore.dispatch(setDataTrack(null));
        const room = getRoom();
        if (room && !isEmpty(room)) {
            discontinueRoom();
        }
        LogFirebase("End_Call", "endCallData", {
            request: payload.callDuration,
        });
        reduxStore.dispatch(handleEndCallAPI(payload));
        setTimeout(() => {
            takePhotoService.takePhotoresetState(); // reset all takephoto service variables
            resetFlagsOnEndCall(true);
        }, 250);
    } else if (PublicVariables.isOnlyUploadImageMeet) {
        ////For upload only call
        uploadFilesService.resetFlags();

        reduxStore.dispatch(resetJoinCallReducer());
        reduxStore.dispatch(setIsCallDisconnected(true));
    }
};

export const handleLocalUserDisconnectFromTheCall = (participants) => {
    const room = getRoom();
    if (singleUserEnabled()) {
        //send stats data on end call also
        callStatsService.setCallStatsInfo(room);
        callStatsService.sendStatsData();
    } else if (reduxStore.getState().callStats.remoteDataForCallStats) {
        reduxStore.dispatch(setRemoteDataForCallStats(false));
        //send stats data on end call also
        callStatsService.setCallStatsInfo(room);
        callStatsService.sendStatsData();
    }
    //// if(_this.dualStreamEnabled()){
    ////    _this.resetGridView();
    ////     _this.removeSlickGallery();
    //// }
    zoomService.disablepinchOnmarkup = false;
    hideRecordingErrorView();
    LogFirebase("TwilioEvents", "room_disconnected", { identity: CALL_DATA.localIdentity });
    // removeLocalTracks()
    handleEndCallFunc();
};

export const handleRemotePartcipantDisconnect = (participant) => {
    const { disconnectedUsersList, allAudioTrackIdentity } = reduxStore.getState().twilioEvents;
    const { partiCountForDisplay, requestMicCameraModalsData } = reduxStore.getState().commonReducer;
    LogFirebase("TwilioEvents", "remote_participant_disconnected", { identity: participant?.identity });
    if (!disconnectedUsersList.includes(participant.identity)) reduxStore.dispatch(addDisconnectedUser(participant.identity));

    const callParticipants = reduxStore.getState().commonReducer.callParticipants;

    // remove audio identity from allAudioTrackIdentity
    const updatedAllAudioTrackIdentity = allAudioTrackIdentity.filter((value) => value.identity !== participant.identity);
    reduxStore.dispatch(setAllAudioTrackIdentity(updatedAllAudioTrackIdentity));

    /* need to handle this later */
    callParticipants.forEach((user) => {
        if (user.identity === participant.identity) {
            if (partiCountForDisplay > 2) {
                handlePlaySoundForParticipantConnectDisconnect(false, participant.identity); // play sound
            }
        }
    });

    if (GLOBAL_MEETING_DATA.isAgent) {
        /* Remove user request data if the user is disconnected. */
        const filteredRequestMicCameraModalsData = requestMicCameraModalsData.reduce((acc, modal) => {
            if (modal.identity !== participant.identity) {
                acc.push(modal); // Only keep if identity doesn't match
            } else {
                const uniqueKey = `${modal.identity}_${modal.request_type}`;
                toast.dismiss(uniqueKey); // Dismiss toast
            }
            return acc;
        }, []);
        reduxStore.dispatch(setRequestMicCameraModalsData(filteredRequestMicCameraModalsData));
    }

    updateParticipantCountForDisplay(participant.identity, "decrement");

    /* - remove participant identity for the array */
    const participantIdentities = reduxStore.getState().twilioEvents.participantIdentities;
    // Create a new array with the desired elements removed
    const updatedParticipantIdentities = participantIdentities.filter((value) => value !== participant.identity);
    reduxStore.dispatch(setParticipantIdentities(updatedParticipantIdentities)); // Dispatch the action with the updated array

    if (GLOBAL_MEETING_DATA.isAgent) {
        // Remove Device Information from remote Participantes DeviceInfo array when participants left the call
        removeRemoteParticipantesDeviceInfo(participant.identity);
    }

    /* - remove activeuserlist, newActiveUserList identity for the object */
    const activeUserList = { ...reduxStore.getState().commonReducer.activeuserlist }; // Create a shallow copy
    const newActiveUserList = { ...reduxStore.getState().commonReducer.newActiveUserList }; // Create a shallow copy
    if (activeUserList && Object.keys(activeUserList).length > 0) {
        if (activeUserList.hasOwnProperty(participant.identity)) {
            // Create a new object without the property to delete
            const updatedActiveUserList = { ...activeUserList };
            const updatedNewActiveUserList = { ...newActiveUserList };
            delete updatedActiveUserList[participant.identity];
            delete updatedNewActiveUserList[participant.identity];

            // Dispatch the action with the updated object
            reduxStore.dispatch(setActiveuserlist(updatedActiveUserList));
            reduxStore.dispatch(setNewActiveUserlist(updatedNewActiveUserList));
        }
    }
    if (dualStreamEnabled()) {
        const participantDetails = {
            identity: participant.identity,
        };
        console.log("setGalleryViewConnectedUser_handleRemotePartcipantDisconnect", participantDetails);

        // Call the function to update or add the participant
        updateOrAddParticipant(participantDetails, true); // removeParticipant = true
    }

    detachParticipantTracks(participant);

    if (dualStreamEnabled() && expandViewEnabled() && isParticipantStreaming(participant.identity)) {
        showGridView(participant.identity, false);
    }

    if (livePointerService.getLivePointerFeatureFlagValue() === ENABLED) {
        livePointerService.removeLivePointerColor(participant.identity);
    }
    if (reduxStore.getState().markup.markupInprogress === MARKUP_VIEW.START_MARKUP_VIEW) {
        markupService.removeAssignedColor(participant.identity);
    }

    /* - remove callparticipant identity for the array */
    const updatedCallParticipants = callParticipants.filter((value) => value.identity !== participant.identity);
    reduxStore.dispatch(setCallParticipants(updatedCallParticipants));
    removeRemoteParticipantesDeviceInfo(participant);

    reduxStore.dispatch(setParticipantCount(partiCountForDisplay));
    const { offlineModeUserIdentity } = reduxStore.getState().offlineMode;
    if (partiCountForDisplay <= 2 && !singleUserEnabled() && offlineModeUserIdentity?.length < 1) {
        if (PublicVariables.isMobile) {
            reduxStore.dispatch(setShowCallDisconnectedPopup(true));
        }
        handleEndCallFunc();
    }
    if (isAgentIdentity(participant.identity)) {
        // if agent disconnect the call (remotely), then silent observer also disconnect from the call
        if (CALL_DATA.isObserver) {
            if (PublicVariables.isMobile) {
                reduxStore.dispatch(setShowCallDisconnectedPopup(true));
            }
            handleEndCallFunc();
        }
    }
};
/* Reset all the reducer and flags after endcall success */
export const resetFlagsOnEndCall = (endCallData) => {
    /* Handle to hide progressbar of waiting screen and reset counter */
    waitingScreenService.showProgressBar(false);
    mediaDeviceService.resetMediaDeviceOnCallEnd();
    reduxStore.dispatch(resetCommonReducer(reduxStore.getState().commonReducer.showCallDisconnectedPopup));
    reduxStore.dispatch(resetTwilioEventsReducer());
    reduxStore.dispatch(resetTrackFailedReducer());
    reduxStore.dispatch(resetChatReducer());
    reduxStore.dispatch(resetImageConatiner());
    reduxStore.dispatch(resetBatteryAndNetworkInfoReducer());
    reduxStore.dispatch(resetRecordingReducer());
    reduxStore.dispatch(resetMarkupReducer());
    reduxStore.dispatch(resetJoinCallReducer());
    reduxStore.dispatch(resetLiveLocationReducer());
    reduxStore.dispatch(resetlivePointerReducer());
    reduxStore.dispatch(resetGalleryViewReducer());
    reduxStore.dispatch({ type: "askAIReducer/resetAskAIReducer" }); // Reset AskAI state on disconnect
    if (measurementService.measurementCanvas) {
        measurementService.stopMeasurementPointer();
    }
    reduxStore.dispatch(resetMeasurementReducer());
    reduxStore.dispatch({ event: BOOKMARK_EVENTS.RESET_BOOKMARK_EVENTS, type: "" });
    reduxStore.dispatch({ event: NOTES_EVENTS.RESET_NOTES, type: "" });
    reduxStore.dispatch(setARMarkupStatusPopup(""));
    reduxStore.dispatch(setARMarkupToastMsgStatus(null));
    arMarkupService.ARMarkupStopVariable();
    reduxStore.dispatch(resetExtractTextReducer());
    clearInterval(PublicVariables.locationIntervalId); // Clearing Location Interval
    remoteParticipantAudioChecker.stop();
    document.body.classList.remove("open-saved-image-sidebar"); // If image conatiner open then settings and add user icon has class to slide it
    document.getElementById("call-action-menu")?.classList?.remove("active");
    addVideoPausedCheck.stop();
    liveCaptionService.resetLiveCaption();
    reduxStore.dispatch(resetLiveCaptionReducer());
    audioTranslationService.resetTranslation();
    reduxStore.dispatch(resetAudioTranslationReducer());
    /* reset Call Data */
    CALL_DATA.disabledFlash = true;
    CALL_DATA.memberToken = "";
    CALL_DATA.agentUserName = "";
    CALL_DATA.localIdentity = "";
    CALL_DATA.participantIdentity = null;
    CALL_DATA.transcriptionId = "";
    const isOfflineModeActive = reduxStore.getState().offlineMode.isOfflineModeActive;
    if (!isOfflineModeActive) {
        CALL_DATA.Latitude = 0;
        CALL_DATA.Longitude = 0;
        CALL_DATA.referenceId = "";
    }
    CALL_DATA.callstatsNetType = "";
    CALL_DATA.callstatsNetSpeed = "";
    CALL_DATA.roomSID = "";
    CALL_DATA.recordingRoomKey = null;
    CALL_DATA.firstTimeUploadForSuccess = true;
    CALL_DATA.firstTimeUploadForFailed = true;
    CALL_DATA.batteryNetworkInfo = {
        batteryState: "",
        batteryObject: null,
        batteryLevel: null,
        localBatteryValue: null,
        localBatteryLow: null,
    };
    CALL_DATA.storageType = null;
    CALL_DATA.myVideoON = false;
    CALL_DATA.myscreenShareON = false;
    CALL_DATA.disabledFlash = true;
    PublicVariables.fromButton = false;
    PublicVariables.onJoinCallAudio = false;
    // if (VideoRoomMonitor.isOpen) {
    //     VideoRoomMonitor.closeMonitor();
    // }
    resetEndCallData(endCallData);
};

export const resetEndCallData = (endCallData) => {
    reduxStore.dispatch(setIsCallDisconnected(endCallData));
    setTimeout(() => {
        CALL_DATA.roomDisconnect = false;
        CALL_DATA.localFlash = true;
        reduxStore.dispatch({ event: END_CALL_EVENTS.RESET_END_CALL, type: "" });
        const isOfflineModeActive = reduxStore.getState().offlineMode.isOfflineModeActive;
        if (!isOfflineModeActive) {
            // do not reset memberId in offline mode is active
            CALL_DATA.memberId = "";
        }
    }, 1000);
};

export const handleParticipantConnect = (participants) => {
    const participantCount = participants.length + 1;
    reduxStore.dispatch(setParticipantCount(participantCount));
    if (participantCount === 2 && !singleUserEnabled()) {
        reduxStore.dispatch(setIsRemoteParticipantJoined(true));
    }
};

export const showLocationSuccess = (position) => {
    if (GLOBAL_MEETING_DATA.isGuest) {
        if (CALL_DATA.firstTimeUploadForSuccess) {
            CALL_DATA.firstTimeUploadForSuccess = false;
            uploadMapService.uploadMap("", position.coords.latitude, position.coords.longitude);
        }
    }
};

export const showLocationError = (error) => {
    switch (error.code) {
        case error.PERMISSION_DENIED:
            if (GLOBAL_MEETING_DATA.isGuest && PublicVariables.featureFlag.ENABLELOCATION === ENABLED && CALL_DATA.firstTimeUploadForFailed) {
                CALL_DATA.firstTimeUploadForFailed = false;
                const locationMessage = {
                    notification_type: NOTIFICATION_TYPES.LOCATION,
                    latitude: 0,
                    longitude: 0,
                    allowedLocation: false,
                    identity: CALL_DATA.localIdentity,
                    isAgent: false,
                    device_type: GLOBAL_MEETING_DATA.device_type,
                };
                sendDataTrack(locationMessage);
                uploadMapService.uploadMap("not shared", 0, 0);
            }
            break;
        case error.TIMEOUT:
            console.error("The request to get user location timed out.");
            break;
    }
};

export const handleErrorForVideo = (error) => {
    reduxStore.dispatch(setIsVideoButtonClickDisable(false)); // enable video button(button click variable)
    if (!DetectRTC.hasWebcam) {
        LogFirebase("video", "Camera not found", "");
        reduxStore.dispatch(setNotAllowedCamera(true));
        reduxStore.dispatch(setVideoError(ERROR_TYPE.NOT_FOUND));
    } else if (!DetectRTC.isWebsiteHasWebcamPermissions || error?.message == "Permission denied" || error?.name == "NotAllowedError") {
        LogFirebase("video", "Camera Permission blocked", { permission: "Camera Permission blocked", error: error });
        reduxStore.dispatch(setNotAllowedCamera(true));
        reduxStore.dispatch(setVideoError(ERROR_TYPE.PERMISSION));
        reduxStore.dispatch(setCameraPermission(MEDIA_PERMISSIONS.BLOCKED)); // set cameraPermission variable
    } else if (error?.name == "NotReadableError" || error?.message == "Could not start video source") {
        const isCallSettingDrawerOpen = reduxStore.getState().commonReducer.isCallSettingDrawerOpen;
        LogFirebase("video", "video_track_creation_failed", { error: error });
        if (isCallSettingDrawerOpen) {
            const errorElement = document.getElementById("callSettingError");
            if (errorElement) {
                errorElement.innerText =
                    Localize[PublicVariables?.currentLanguageObj?.languageCode]["failed_to_start_video_camera"] +
                    " " +
                    Localize[PublicVariables?.currentLanguageObj?.languageCode]["please_select_another_video_camera"];
            }
        } else {
            reduxStore.dispatch(setNotAllowedCamera(true));
            reduxStore.dispatch(setVideoError(ERROR_TYPE.NOT_READABLE));
        }
    } else if (DetectRTC.hasWebcam && DetectRTC.isWebsiteHasWebcamPermissions) {
        // camera is there and permission has given, although error was come
        reduxStore.dispatch(setNotAllowedCamera(true));
        reduxStore.dispatch(setVideoError(ERROR_TYPE.NOT_FOUND));
    }
    micCameraPermissionDatatrackSend("cam"); // send data track for video permission status send to agent
};

export const handleErrorForAudio = () => {
    if (!DetectRTC.hasMicrophone) {
        LogFirebase("Micinfo", "microphone_not_found", "");
        reduxStore.dispatch(setAudioErrorModal(true));
        reduxStore.dispatch(setAudioError(ERROR_TYPE.NOT_FOUND)); // handle error for audio
    } else if (!DetectRTC.isWebsiteHasMicrophonePermissions) {
        LogFirebase("Micinfo", "no_microphone_permission", "");
        reduxStore.dispatch(setAudioPermission(MEDIA_PERMISSIONS.BLOCKED)); // set audioPermission variable
        reduxStore.dispatch(setAudioErrorModal(true));
        reduxStore.dispatch(setAudioError(ERROR_TYPE.PERMISSION)); // handle error for audio
    } else {
        /* example: Not readable error (The I/O read opration failed) */
        reduxStore.dispatch(setAudioError(ERROR_TYPE.NOT_READABLE));
        reduxStore.dispatch(setAudioErrorModal(true));
        LogFirebase("Audio", "audio_track_creation_failed", "general error popupshow");
    }
    micCameraPermissionDatatrackSend("mic"); // send data track for audio permission status send to agent
};

export const triggerHaptic = () => {
    if (PublicVariables.isMobile) {
        if (navigator.vibrate) {
            navigator.vibrate(100); // vibrate for 100ms
        } else {
            console.warm("navigator.vibrate is not supported");
        }
    }
};

export const handleStartStopVideoPlaySound = (fromConnect) => {
    try {
        if (fromConnect === true) {
            const audio = new Audio(videoON);
            audio.play();
        } else {
            const audio = new Audio(videoOff);
            audio.play();
        }
        triggerHaptic(); // trigrred heptic effect
    } catch (e) {
        console.log(e);
    }
};

export const handleStartStopAudioPlaySound = (fromConnect) => {
    try {
        if (fromConnect === true) {
            const audio = new Audio(micON);
            audio.play();
        } else {
            const audio = new Audio(micOff);
            audio.play();
        }
        triggerHaptic(); // trigrred heptic effect
    } catch (e) {
        console.log(e);
    }
};

/* - handle sound for participant connect and disconnect call */
export const handlePlaySoundForParticipantConnectDisconnect = (fromConnect, identity) => {
    try {
        if (!isSilentObserver(identity)) {
            if (fromConnect === true) {
                const audio = new Audio(newUserJoinSound);
                audio.play();
            } else {
                const audio = new Audio(userDisconnectSound);
                audio.play();
            }
        }
    } catch (e) {
        console.log(e);
    }
};
/* check the video view is expanded or not  */
export const expandViewEnabled = () => {
    return reduxStore.getState().commonReducer.expandView;
};

export const isLocalUserVideoOn = () => {
    return reduxStore.getState().twilioEvents.startLocalVideo;
};

export const handleAudioFirebaseAndGoogleEvent = (identity, isAudioAvailable) => {
    if (!isAudioAvailable) {
        // audio going to enable
        LogFirebase("Audio", "Unmute_audio", "ON");
        LogFirebase("Audio", "audio_track_created", { identity: identity }); // , room_Name: room.name
        if (isSilentObserver(identity)) {
            googleEvent.logEvent(EVENT_NAME.WHISPER_ON);
            LogFirebase("SilentObserver", "WHISPER_ON", "");
        } else {
            googleEvent.logEvent(EVENT_NAME.MICROPHONE_UNMUTED);
        }
    } else {
        // audio going to disable
        LogFirebase("Audio", "mute_audio", "OFF");
        if (isSilentObserver(identity)) {
            googleEvent.logEvent(EVENT_NAME.WHISPER_OFF);
            LogFirebase("SilentObserver", "WHISPER_OFF", "");
        } else {
            googleEvent.logEvent(EVENT_NAME.MICROPHONE_MUTED);
        }
    }
};

export const getUserDetailsById = (id) => {
    // Default result
    let result = null;

    // Get the callParticipants from Redux state
    const callParticipants = reduxStore.getState().commonReducer.callParticipants;

    // Check if ID is valid and callParticipants is available
    if (id != undefined && callParticipants) {
        // Find the user with the given ID
        callParticipants.forEach(function (user) {
            if (user.identity == id) {
                result = user;
            }
        });
    }

    return result;
};

// Helper to check if the device type matches the app type or default types
const checkIfDeviceTypeMatches = (selectedAppType) => {
    const { streamingPartiIdentity } = reduxStore.getState().twilioEvents;
    const userDetails = getUserDetailsById(streamingPartiIdentity);

    if (selectedAppType) {
        return userDetails?.device_type === selectedAppType;
    }
    return userDetails?.device_type == DEVICE_TYPES.ANDROID_APP || userDetails?.device_type == DEVICE_TYPES.IOS_APP;
};

/* -check is streaming user's video or screenshare is on */
export const isStreamingUserVideoOrScreenShareOn = (selectedAppType, isForVideo) => {
    // isStreamingUserScreenShare and isStreamingAppUserVideoOn common function
    let isScreenShareOrVideo = false;

    // Check if the device type matches the selected app type or default to app devices
    const deviceTypeIsApp = checkIfDeviceTypeMatches(selectedAppType);

    if (deviceTypeIsApp) {
        const room = getRoom();
        room?.participants?.forEach((remoteParticipant) => {
            if (!isScreenShareOrVideo && isParticipantStreaming(remoteParticipant.identity)) {
                const trackArr = getTracksByType(remoteParticipant, "video");
                trackArr.forEach((track) => {
                    isScreenShareOrVideo = isForVideo ? !isScreenshareTrack(track) : isScreenshareTrack(track);
                    return isScreenShareOrVideo;
                });
            }
        });
    }
    return isScreenShareOrVideo;
};

/* check any one's video or screenshare enabled or not  */
export const isvideoenabled = () => {
    const { screenSharingUsers, videoStreamingUsers } = reduxStore.getState().twilioEvents;
    return !isEmpty(videoStreamingUsers) || !isEmpty(screenSharingUsers);
};

/* - Android/iOS APP is streaming user */
export const AppIsStreaming = (fromWhere) => {
    return new Promise((resolve, reject) => {
        const { streamingPartiIdentity } = reduxStore.getState().twilioEvents;
        let userdetails = getUserDetailsById(streamingPartiIdentity);

        if (
            (!fromWhere && isStreamingUserVideoOrScreenShareOn(DEVICE_TYPES.ANDROID_APP, false)) ||
            (fromWhere == "ARMarkup" &&
                (isStreamingUserVideoOrScreenShareOn(DEVICE_TYPES.ANDROID_APP, true) ||
                    isStreamingUserVideoOrScreenShareOn(DEVICE_TYPES.IOS_APP, true)))
        ) {
            if (isLiveStreamFeatureSupported(userdetails) || fromWhere == "ARMarkup") {
                resolve(true);
            } else {
                reject(false);
            }
        } else {
            reject(false);
        }
    });
};

// Initializing new joined participant device information to default values.
export const initializeRemoteParticipantDeviceInfo = (identity) => {
    const { remoteParticipantesDeviceInfo } = reduxStore.getState().commonReducer;
    const participantsInfo = { ...remoteParticipantesDeviceInfo };
    //initialize quality array with false
    participantsInfo[identity] = {
        isAudioEnabled: false,
        isVideoEnabled: false,
    };

    reduxStore.dispatch(setRemoteParticipantesDeviceInfo(participantsInfo));
};

// Remove Device Information from remoteParticipantesDeviceInfo array whne participants left the call
export const removeRemoteParticipantesDeviceInfo = (identity) => {
    const { remoteParticipantesDeviceInfo } = reduxStore.getState().commonReducer;
    const participantsInfo = { ...remoteParticipantesDeviceInfo };

    // remove object from the array
    if (participantsInfo.hasOwnProperty(identity)) {
        delete participantsInfo[identity];
        reduxStore.dispatch(setRemoteParticipantesDeviceInfo(participantsInfo));
    }
};

// Set Remote participant device info for audio video status
// old function showAudioVideoStatus
export const setRemoteParticipanteAudioVideoStatus = (fromWhere, identity, value) => {
    const { remoteParticipantesDeviceInfo } = reduxStore.getState().commonReducer;
    const participantsInfo = { ...remoteParticipantesDeviceInfo };
    if (fromWhere === "audio") {
        participantsInfo[identity] = {
            ...(participantsInfo[identity] || { isVideoEnabled: false }), // Preserve existing data or initialize
            isAudioEnabled: value, // Update or set the audio status
        };
        if (participantsInfo[identity].isAudioEnabled) {
            handleAllEnabledAudioTrackIdenity(identity);
        } else if (!participantsInfo[identity].isAudioEnabled) {
            handleRemoveEnabledAudioTrackIdenity(identity);
        }
        reduxStore.dispatch(setRemoteParticipantesDeviceInfo(participantsInfo));
    } else if (fromWhere === "video") {
        if (participantsInfo[identity]) {
            participantsInfo[identity] = {
                ...participantsInfo[identity], // Preserve existing data
                isVideoEnabled: value, // Update the video status
            };
            reduxStore.dispatch(setRemoteParticipantesDeviceInfo(participantsInfo));
        }
    }

    console.log("showAudioVideoStatus_remoteParticipantesDeviceInfo - ", participantsInfo);
};

const handleIncrementDecrement = (from, partiCountForDisplay) => {
    if (from == "increment") {
        reduxStore.dispatch(setPartiCountForDisplay(parseInt(partiCountForDisplay) + 1));
    } else if (from == "decrement") {
        reduxStore.dispatch(setPartiCountForDisplay(parseInt(partiCountForDisplay) - 1));
    }
};

export const updateParticipantCountForDisplay = (identity, from) => {
    const { partiCountForDisplay } = reduxStore.getState().commonReducer;
    handleIncrementDecrement(from, partiCountForDisplay);
};

export function getAudioTrackStatusForAllParticipants(room) {
    if (!room) return {};

    const status = {};

    const allParticipants = [room.localParticipant, ...Array.from(room.participants.values())];

    allParticipants.forEach((participant) => {
        const publication = Array.from(participant.audioTracks.values())[0];
        const track = publication?.track;
        status[participant.identity] = {
            isAudioEnabled: track?.isEnabled ?? false,
        };
    });

    return status;
}

export const updateAudioStatus = (timeout = 0) => {
    const room = getRoom();

    setTimeout(() => {
        const audioStatus = getAudioTrackStatusForAllParticipants(room);
        reduxStore.dispatch(setAllUserAudioStatus(audioStatus));
    }, timeout);
};

export const getActiveParticipantCount = () => {
    const room = getActiveRoom();
    return room?.participants?.size + 1;
};
